/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolBoltIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-bolt"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M8.63 15.63L5.9 15.63Q5.1 15.63 4.74 14.91Q4.38 14.2 4.83 13.55L13.28 1.35Q13.55 0.97 13.97 0.82Q14.4 0.68 14.82 0.85Q15.25 1.02 15.49 1.41Q15.72 1.8 15.68 2.25L14.78 9.38L18.3 9.38Q19.15 9.38 19.51 10.14Q19.88 10.9 19.32 11.55L10.1 22.7Q9.82 23.05 9.4 23.15Q8.97 23.25 8.55 23.05Q8.13 22.85 7.92 22.46Q7.72 22.07 7.78 21.65Z" fill={color} />
    </svg>
  );
}
